import * as m from '~/paraglide/messages'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '~/shared/ui/card'
import { CountrySelect } from '~/shared/ui/country-select'
import { Input } from '~/shared/ui/input'
import { Label } from '~/shared/ui/label'

interface ListingLocationSectionProps {
  // biome-ignore lint/suspicious/noExplicitAny: TanStack Form API
  form: any
}

export function ListingLocationSection({ form }: ListingLocationSectionProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{m.location()}</CardTitle>
        <CardDescription>{m.whereIsYourBusinessLocated()}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <form.Field name="location.name">
          {/* biome-ignore lint/suspicious/noExplicitAny: TanStack Form field API */}
          {(field: any) => (
            <div className="space-y-2">
              <Label htmlFor={field.name}>{m.locationNameOptional()}</Label>
              <Input
                id={field.name}
                name={field.name}
                value={field.state.value}
                onBlur={field.handleBlur}
                onChange={(e) => field.handleChange(e.target.value)}
                placeholder={m.buildingNameMallEtc()}
              />
            </div>
          )}
        </form.Field>

        <form.Field name="location.street">
          {/* biome-ignore lint/suspicious/noExplicitAny: TanStack Form field API */}
          {(field: any) => (
            <div className="space-y-2">
              <Label htmlFor={field.name}>{m.streetAddress()}</Label>
              <Input
                id={field.name}
                name={field.name}
                value={field.state.value}
                onBlur={field.handleBlur}
                onChange={(e) => field.handleChange(e.target.value)}
                placeholder={m.addressPlaceholder()}
                required
              />
            </div>
          )}
        </form.Field>

        <div className="gap-4 grid grid-cols-1 xs:grid-cols-[minmax(0,1fr)_minmax(0,2fr)]">
          <form.Field name="postalCode">
            {/* biome-ignore lint/suspicious/noExplicitAny: TanStack Form field API */}
            {(field: any) => (
              <div className="space-y-2">
                <Label htmlFor={field.name}>{m.listingPostalCode()}</Label>
                <Input
                  id={field.name}
                  name={field.name}
                  value={field.state.value ?? ''}
                  onBlur={field.handleBlur}
                  onChange={(e) => field.handleChange(e.target.value)}
                  autoComplete="postal-code"
                  maxLength={12}
                />
              </div>
            )}
          </form.Field>

          <form.Field name="location.city">
            {/* biome-ignore lint/suspicious/noExplicitAny: TanStack Form field API */}
            {(field: any) => (
              <div className="space-y-2">
                <Label htmlFor={field.name}>{m.city()}</Label>
                <Input
                  id={field.name}
                  name={field.name}
                  value={field.state.value}
                  onBlur={field.handleBlur}
                  onChange={(e) => field.handleChange(e.target.value)}
                  required
                />
              </div>
            )}
          </form.Field>
        </div>

        <div className="gap-4 grid grid-cols-1 xs:grid-cols-2">
          <form.Field name="location.country">
            {/* biome-ignore lint/suspicious/noExplicitAny: TanStack Form field API */}
            {(field: any) => (
              <div className="space-y-2">
                <Label htmlFor={field.name}>{m.country()}</Label>
                <CountrySelect
                  id={field.name}
                  name={field.name}
                  value={field.state.value}
                  onBlur={field.handleBlur}
                  onChange={field.handleChange}
                  placeholder={m.selectACountry()}
                  required
                />
              </div>
            )}
          </form.Field>
        </div>
      </CardContent>
    </Card>
  )
}
